import React, { Component } from "react";
import * as Constants from "../../common/Global/constants";
import * as TemplateConstants from "../../common/Global/templateConstants";
import { getLocalStorageVariables, isEmptyVariable, ifEmptyReturn, isEmptyArray, getOnlyFileNameFromPath, truncateString, isJsonString, handleTokenExpiry } from "../../common/Global/commonFunctions";
import { AddNewButtonLayout, TableIcon } from "../../common/Global/globalStyles.style";
import AddNewResponseDialog from "./addNewResponseDialog";
import AlertDialog from "../../common/AlertDialog";
import { Modal } from "react-bootstrap";

let userDetails = getLocalStorageVariables();

class ViewResponseCommentDialog extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			componentDidMountFlag: false,
			showLoader: false,
			employeesList: [],
			showCreateDialog: false,
			target:[],
			isEdit:false,
			templateValues:[],
			responseTemplateFields:[],
			supportings:[],
			responseTemplateValues:[],
			observationResponses:[],
			showBtnLoader: false,
			showSubmitConfirmDialog: false,
			reOpenRemark: "",
			showReopenRemark: false,
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidMount() {}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showViewResponseDialog) {
			this.setState({
				componentDidMountFlag: false,
				showLoader: false,
				employeesList: [],
				showCreateDialog: false,
				target:[],
				isEdit:false,
				responseTemplateValues:[],
				reOpenRemark: "",
				showReopenRemark: false,
			},() => {
				this.getInitData();
			});
		}
	}
	handleCreateDialogShow = () => {
		this.setState({
			showCreateDialog: true,
			selectedId: "",
			isEdit: false,
		});
	};
	handleEditDialogShow = () => {
		this.setState({
			showCreateDialog: true,
			selectedId: "",
			isEdit: true,
		});
	};

	handleAddDialogClose = (reloadFlag) => {
		this.setState({
			showCreateDialog: false,
		},() => {
			if (reloadFlag == true) this.getInitData();
		}
		);
	};

	handleReopenRemarkShow = () => {
		this.setState({ showReopenRemark: true });
	};

	handleReopenRemarkClose = () => {
		this.setState({ showReopenRemark: false });
	};

	handleSubmitConfirmShow = () => {
		this.setState({ showSubmitConfirmDialog: true });
	};

	handleSubmitConfirmClose = () => {
		this.setState({ showSubmitConfirmDialog: false });
	};

	handleSubmitResponse = () => {
		this.setState({ showSubmitConfirmDialog: false, showBtnLoader: true });

		const formData = new FormData();
		formData.append('email', userDetails.email);
		formData.append('accessToken', userDetails.accessToken);
		formData.append('assignmentId', this.props.assignmentId);

		if (!isEmptyVariable(this.props.observationId)) {
			formData.append('observationId', this.props.observationId);
		} else if (!isEmptyVariable(this.props.assignmentTaskId)) {
			formData.append('assignmentTaskId', this.props.assignmentTaskId);
		}

		formData.append('isResponseSubmitted', true);

		let responseFieldTypeMap = {};
		this.state.responseTemplateFields.forEach(item => {
			responseFieldTypeMap[item.fieldId] = item.fieldType;
		});
		let templateValues = Object.entries(this.state.responseTemplateValues)
			.filter(([_key, value]) => {
				if (value === "") return false;
				if (!isJsonString(value)) return true;
				const parsedValue = JSON.parse(value);
				return !Array.isArray(parsedValue) || parsedValue.length > 0;
			})
			.map(([k, v]) => ({ fieldId: k, fieldType: responseFieldTypeMap[k], value: v }));
		formData.append('templateValues', JSON.stringify(templateValues));

		const response0 = this.state.observationResponses[0];

		if (response0?.immediate === "Y") {
			formData.append('immediate', response0.immediate);
		} else {
			formData.append('immediate', "N");
		}

		if (response0?.continuous === "Y") {
			formData.append('continuous', response0.continuous);
		} else {
			formData.append('continuous', "N");
		}

		if (isEmptyVariable(response0?.customTarget)) {
			formData.append('customTarget', "");
		} else {
			formData.append('customTarget', response0.customTarget);
		}

		const remarks = this.state.supportings.map(item => ({
			fileName: item.filePath,
			responseSupportingMapId: item.responseSupportingMapId,
			remark: item.remarks
		}));
		formData.append('remarks', JSON.stringify(remarks));
		formData.append('userType', 'ae');

		fetch(Constants.UpdateDraftResponse, {
			method: "POST",
			mode: 'cors',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (handleTokenExpiry(data.responseCode)) return;
			if (data.responseCode === Constants.CODE_SUCCESS) {
				this.setState({ showBtnLoader: false }, () => {
					this.props.handleViewResponseDialogClose(true);
				});
			} else {
				this.setState({ showBtnLoader: false });
			}
		});
	};

	downloadAttachment = (documentPath,e) => {
        e.stopPropagation();
        fetch(Constants.API_SERVER_PATH+documentPath)
        .then(response => { return response.blob(); } )
        .then(blob => {
            let fileName = getOnlyFileNameFromPath(documentPath);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

	getInitData = () => {
		this.setState({
			showLoader: true,
		});

		let url = Constants.GetAuditeeEmployeeDraftReports+"/"+this.props.assignmentId+"/observations/responses";

		let params = {
			email: userDetails.email,
			accessToken: userDetails.accessToken
		}

		if(!isEmptyVariable(this.props.observationId)){
			params.observationId = this.props.observationId
		}else if(!isEmptyVariable(this.props.assignmentTaskId)){
			params.assignmentTaskId = this.props.assignmentTaskId
		}

		fetch(url, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(params),
		})
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			if(handleTokenExpiry(data.responseCode)) return;
			else if (data.responseCode === Constants.CODE_SUCCESS) {
				let targetArr = [];
				let target = "";
				let responseTemplateFields = [];
				let supportings = [];
				let employees = data.data.employeeList;
				let observationResponse = data.data.observationResponseList;
				supportings = data.data.supportingList;
				if(!isEmptyVariable(data.data.responseTemplateFields)){
					try{
						responseTemplateFields = JSON.parse(data.data.responseTemplateFields)
					}catch(e){}
				}
				if(!isEmptyArray(observationResponse)){
					if(!isEmptyVariable(observationResponse[0].immediate) && observationResponse[0].immediate === "Y" ){
						targetArr.push("Immediate");
					}
					if(!isEmptyVariable(observationResponse[0].continuous) && observationResponse[0].continuous === "Y" ){
						targetArr.push("Continuous");
					}
					if(!isEmptyVariable(observationResponse[0].customTarget)){
						targetArr.push(observationResponse[0].customTarget);
					}
					target = targetArr.join(", ")
				}
				let tmpTemplaveValues = {};
				if(!isEmptyArray(observationResponse)){
					try{
						let tmpValues = observationResponse;
						tmpValues.map(e=>{
							const key = e["fieldId"]
							tmpTemplaveValues[key] = e["value"]
						})
					}catch(e){}
				}
				let reOpenRemark = "";
				if (!isEmptyArray(observationResponse) && !isEmptyVariable(observationResponse[0].reOpenRemark)) {
					reOpenRemark = observationResponse[0].reOpenRemark;
				}

				this.setState({
					employeesList: employees,
					observationResponses:observationResponse,
					showLoader: false,
					supportings:supportings,
					responseTemplateFields:responseTemplateFields,
                    responseTemplateValues:tmpTemplaveValues,
					componentDidMountFlag: true,
					target:target,
					reOpenRemark: reOpenRemark,
				});
			} else {
				this.setState({
					employeesList: [],
					showLoader: false,
					componentDidMountFlag: true,
				});
			}
		});
	};

	render() {
		return (
			<Modal className="review-history-dialog custom-dialog" show={this.props.showViewResponseDialog} onHide={this.props.handleViewResponseDialogClose}>
				<Modal.Header>
					<h5>Response</h5>
					<button onClick={this.props.handleViewResponseDialogClose} type="button" data-dismiss="modal">
						<span class="material-icons">close</span>
					</button>
				</Modal.Header>
				<hr />
				<div className="modal-body">
					{this.state.showLoader && (
						<div class="loader"></div>
					)}
					<div className="review-history-wrapper">
						{
							<>
							<div className="search-addnew-bg">
								<div className="search-addnew">
									<div></div>
									<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
										{!isEmptyVariable(this.state.reOpenRemark) && (
											<div className="tool ml-2 c-pointer" data-title="View Remark">
												<span
													className="material-icons"
													title="View Reopen Remark"
													onClick={this.handleReopenRemarkShow}
													style={{
                                                        color: `rgba(${this.props.themeSettings.themeColor.r},${this.props.themeSettings.themeColor.g},${this.props.themeSettings.themeColor.b},1)`,
                                                        verticalAlign: "middle",
                                                        fontSize: 22,
                                                        cursor: "pointer"
                                                    }}
												>
													info
												</span>
											</div>
										)}
										<AddNewButtonLayout themeSettings={this.props.themeSettings}>
											{
												isEmptyArray(this.state.observationResponses) ?
												<a onClick={this.handleCreateDialogShow} href="javascript:void(0);">
													<span className="material-icons">add_circle</span>
													<p>Add New</p>
												</a>
												:
												(!isEmptyArray(this.state.observationResponses) &&
												this.state.observationResponses[0].isFrozenForClient === "N") &&
												<a onClick={this.handleEditDialogShow} href="javascript:void(0);">
													<span className="material-icons">edit</span>
													<p>Edit Response</p>
												</a>
											}
										</AddNewButtonLayout>
									</div>
								</div>
							</div>
							</>
						}
						
						{this.state.componentDidMountFlag && (
							<div className="review-history-list">
								<div className="history-item-layout">
								{this.state.responseTemplateFields.filter(item => item.userOnlyField !== "Y").map((item,index)=>{
									let isFieldIdCheck = isEmptyVariable(this.state.responseTemplateValues[item.fieldId]);
									let fieldIdValue = this.state.responseTemplateValues[item.fieldId];
									let employeeName = [];
									if(item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
										item.isResponsibilityField == "Y" && item?.isResponsibilityFieldEnabled === "Y"){
										this.state.employeesList.map(e => {
											!isFieldIdCheck && JSON.parse(fieldIdValue).map(id => {
												if(id == e.employeeId){
													employeeName.push(e)
												}
											})
										})
									}
									return (
										<>
											{/* {
												index == 1 && !isEmptyVariable(this.state.target) &&
												<span>Target : {" "+this.state.target}</span>
											} */}
											{(item.fieldType === TemplateConstants.FIELD_TYPE_TEXT ||
												item.fieldType === TemplateConstants.FIELD_TYPE_DATE ||
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
												item.fieldType === TemplateConstants.FIELD_TYPE_OPEN_CLOSED) &&
												!isFieldIdCheck && <span>{item.fieldName} : {" "}{fieldIdValue}</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
												item.isResponsibilityField == "Y" && item?.isResponsibilityFieldEnabled === "Y" && !isFieldIdCheck && 
												<span>{item.fieldName} : {" "}
												{employeeName.map((item, index) => {
													return <>{(index ? ", " : "") + ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName}</>
												})}</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
												isEmptyVariable(item.isResponsibilityField) && !isFieldIdCheck && 
												<span>{item.fieldName} : {" "}
													{isJsonString(fieldIdValue) ? JSON.parse(fieldIdValue).join(", ") : fieldIdValue}
												</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_TABLE && !isFieldIdCheck && 
												<>
													{(item.fieldName + " : ")}
													<table class="table instances-table custom-table">
														{
															!isFieldIdCheck && JSON.parse(fieldIdValue).map((rowItem, rowIndex) =>  {
																if(rowIndex === 0){
																	return <thead className="instances-thead display-table">
																		<tr>
																		{
																			rowItem.map((colItem, colIndex) => {
																				return <th width={colItem === "Action"?"5%":""} className= {colItem === "Action"?"text-center":""}>
																					<div className="instances-table-header">
																						<p>
																							{colItem === "Action" ? "" : colItem}
																						</p>
																					</div>
																				</th>
																			})
																		}
																		</tr>
																	</thead>
																}else{
																	return <tbody className="instances-thead display-table">
																		<tr>
																		{
																			rowItem.map((colItem, colIndex) => {
																				return <td
																					className={colItem === "Action" ? "text-center" : ""}
																				>
																					{colItem === "Action" ? "" : colItem}
																				</td>
																			})
																		}
																		</tr>
																	</tbody>
																}
															})
														}
													</table>
												</>
											}
										</>
									)
								})}
								</div>
								{!isEmptyArray(this.state.supportings) &&
									<div className="common-tab-bg">
										<div className="common-table" style={{width:"100%"}}>
											<table className="table">
												<thead>
													<tr>
														<th className="text-center" width={"5%"}>No.</th>
														<th width={"5%"}>File Name</th>
														<th width={"5%"}>Remarks</th>
														<th className="text-center" width={"5%"}>Download</th>
													</tr>
												</thead>
												<tbody>
													{this.state.supportings.map((item,index) => {
														return(
															<tr>
																<td className="text-center">{(index+1)}</td>
																<td>{getOnlyFileNameFromPath(item.filePath)}</td>
																<td>{truncateString(item.remarks,Constants.STRING_LENGTH)}</td>
																<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																	<span class="material-icons" onClick={this.downloadAttachment.bind(this, item.filePath)}>get_app</span>
																</TableIcon>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</div>
								}
							</div>
						)}
						{this.state.componentDidMountFlag && isEmptyArray(this.state.observationResponses) && 
						isEmptyArray(this.state.supportings) && (
							<div className="dialog-no-records">
								<p>{Constants.NO_RECORDS_WARNING}</p>
							</div>
						)}
					</div>
					{!isEmptyArray(this.state.observationResponses) &&
					this.state.observationResponses[0].isFrozenForClient === "N" && (
						<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 5px" }}>
							<AddNewButtonLayout themeSettings={this.props.themeSettings}>
								<a onClick={this.handleSubmitConfirmShow} href="javascript:void(0);">
									<p>Submit</p>
								</a>
							</AddNewButtonLayout>
						</div>
					)}
				</div>

				<AddNewResponseDialog
					showAddResponseDialog={this.state.showCreateDialog}
					handleAddResponseDialogClose={this.handleAddDialogClose}
					observationId= {this.props.observationId}
					themeSettings={this.props.themeSettings}
                    assignmentId = {this.props.assignmentId}
					assignmentTaskId={this.props.assignmentTaskId}
					isEdit={this.state.isEdit}
					responseObj={this.state.observationResponses}
					supportings={this.state.supportings}
					responseTemplateFields={this.state.responseTemplateFields}
					employees={this.state.employeesList}
				/>

				<AlertDialog
					showAlertDialog={this.state.showSubmitConfirmDialog}
					handleAlertDialogClose={this.handleSubmitConfirmClose}
					type={Constants.ALERT_TYPE_WARNING}
					alertDialogHeading={"Submit Response"}
					alertDialogMessage={"You are about to submit the response. Hope the comment is finalised. You will not be able to edit the comment further or see the observation. Do you want to submit?"}
					proceedBtnClick={this.handleSubmitResponse}
					proceedBtnLabel={"Submit"}
					showLoader={this.state.showBtnLoader}
					themeSettings={this.props.themeSettings}
				/>

				<AlertDialog
					showAlertDialog={this.state.showReopenRemark}
					handleAlertDialogClose={this.handleReopenRemarkClose}
					type={Constants.ALERT_TYPE_ALERT}
					alertDialogHeading={"Reopen Remark"}
					alertDialogMessage={this.state.reOpenRemark}
					proceedBtnClick={this.handleReopenRemarkClose}
					proceedBtnLabel={"Okay"}
					themeSettings={this.props.themeSettings}
				/>

			</Modal>
		);
	}
}

export default ViewResponseCommentDialog;
